import {FC} from 'react';
import {AppBar, IconButton, Toolbar, Typography, useTheme} from "@mui/material";
import ResearchInput from "./ResearchInput";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../contexts/AuthContext";

const MyAppBar: FC<{}> = () => {
    const theme = useTheme()
    const navigate = useNavigate()
    const {dispatch} = useAuth();

    const handleLogout = async () => {
        dispatch({type: 'LOGOUT'});
        console.log('User logged out');
        setTimeout(() => {
            navigate("/home")
        }, 0);

    }
    return (
        <AppBar position="fixed" sx={{backgroundColor: theme.palette.primary.main, backgroundImage:"none",zIndex: theme.zIndex.drawer + 1}}>
            <Toolbar sx={{justifyContent: "space-between"}}>
                <Typography variant="h6" noWrap component="div">
                    Ma Visiotech
                </Typography>
                <ResearchInput/>
                <IconButton color="default" aria-label="Disconected" onClick={handleLogout}>
                    <PowerSettingsNewIcon/>
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};

export default MyAppBar;
